/**
 * @ngdoc service
 * @name billing.number-circles.factory:NumberCircles
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.number-circles')
    .factory('NumberCircle', [
        '$translate',
        'Resource',
        NumberCircle
    ]);

function NumberCircle($translate, Resource) {
    var $model = Resource.make('billing/number-circles');
    $model.title = 'NumberCircle ';

    $model.schema = {
        type: 'object',
        title: $translate.instant('billing.number-circles.title'),
        properties: {
            id: {
                title: $translate.instant('billing.number-circles.labels.id'),
                type: 'number',
                listview: 'hidden',
                mergeable: false
            },
            title: {
                title: $translate.instant('billing.number-circles.labels.title'),
                type: 'string',
                columnDef: {
                    main: true
                }
            },
            number_template: {
                title: $translate.instant('billing.number-circles.labels.number_template'),
                type: 'string',
                columnDef: {}
            },
            start_number: {
                title: $translate.instant('billing.number-circles.labels.start_number'),
                type: 'string',
                columnDef: {}
            }
        }
    };


    $model.form = [
        'title',
        'number_template',
        'start_number'
    ];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/number-circles/factories/number-circle-factory.js